import { render, staticRenderFns } from "./ItemOutput.vue?vue&type=template&id=1cde8da0&scoped=true&"
import script from "./ItemOutput.vue?vue&type=script&lang=ts&"
export * from "./ItemOutput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cde8da0",
  null
  
)

export default component.exports